"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ui_1 = require("@phishtool/ui");
exports.default = (0, ui_1.getTheme)();
